var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGamingTrophyCheckSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 8.43311L18.8833 17.5481C18.7674 17.6642 18.6297 17.7563 18.4781 17.8192C18.3266 17.882 18.1641 17.9144 18 17.9144C17.8359 17.9144 17.6734 17.882 17.5219 17.8192C17.3703 17.7563 17.2326 17.6642 17.1167 17.5481L14.25 14.6831",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4932 26.2485V31.2485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1014 38.7481C30.3259 36.5543 28.8893 34.6549 26.9894 33.3114C25.0896 31.968 22.82 31.2466 20.4931 31.2466C18.1662 31.2466 15.8966 31.968 13.9967 33.3114C12.0969 34.6549 10.6603 36.5543 9.88477 38.7481H31.1014Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.75 10.0002C36.75 14.31 35.038 18.4432 31.9905 21.4907C28.943 24.5382 24.8098 26.2502 20.5 26.2502C16.1902 26.2502 12.057 24.5382 9.00952 21.4907C5.96205 18.4432 4.25 14.31 4.25 10.0002V3.74854C4.25 3.08549 4.51339 2.44961 4.98223 1.98077C5.45107 1.51193 6.08696 1.24854 6.75 1.24854H34.25C34.913 1.24854 35.5489 1.51193 36.0178 1.98077C36.4866 2.44961 36.75 3.08549 36.75 3.74854V10.0002Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamingTrophyCheckSuccess);
export default __webpack_public_path__ + "static/media/gaming-trophy-check-success.9960e5faa70dc19138395dc927eec309.svg";
export { ForwardRef as ReactComponent };